export default __webpack_public_path__ + "static/media/coin-socket-red.cbb800a7.jpg";